import { render, staticRenderFns } from "./AssetReferencesTab.vue?vue&type=template&id=3f985bc7"
import script from "./AssetReferencesTab.vue?vue&type=script&lang=js"
export * from "./AssetReferencesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports